import instance from "@/services/http.interceptor";
import cookies from "js-cookie";
import { parse } from "querystring";

// const testUcToken = "";
// const testProToken = "";
// const testNftToken = "";

// const testUcToken = "XYdNMAcZZ9NB1mjdXgt30DVeIutovWyOMHxqw7oM/Y8LFZ75GpVVXD0rSLKKGrOisy5ZCZpcExXc4YCS4TmiJxghkv4Inr4wGdoFx4z51TtVenF+E3IPT2S06LnNSRMIzP9IKHpM8IP9qSNiES8ytAn0XZnQjj70AxwIOeD7KOHgTElewYdPmqE7GbU3Egl6ZCjytEDqIKG3nkpDb31cvA==";
// const testProToken = "8uL4vi37e6QTjCyWgSAPBo-45WCgtPf8ufwhwmQk3d4Y-uOP2m0-gvjE57ad1qDF";
// const testNftToken = "";

// sessionStorage.setItem('HB-PRO-TOKEN',testProToken)
// sessionStorage.setItem('HB-UC-TOKEN',testUcToken)

// 登录状态拦截
const mainCode = [555, 10001];
const proCode = ["token-not-valid", "login-required", 1003, 301001];
const ucCode = [512, 403];
const otcCode = [401];
const poolCode = [100001];
const dmCode = [1011];
const nftCode = [115, 116, 125];
export const authContact = [
  ...mainCode,
  ...proCode,
  ...ucCode,
  ...otcCode,
  ...poolCode,
  ...dmCode,
  ...nftCode,
];

const tokenKeys = (keys) => {
  const param: any = parse(window.location.search.slice(1));
  const invite_code_special = param.invite_code || "";
  const crm_token =
    cookies.get(invite_code_special) ||
    sessionStorage.getItem(invite_code_special) ||
    "";
  const keysList = {
    uc: {
      "HUOBI-BUSINESS": "PRO",
      "HB-UC-TOKEN":
        cookies.get("HB-UC-TOKEN") ||
        sessionStorage.getItem("HB-UC-TOKEN") ||
        "",
      "HB-PRO-TOKEN":
        cookies.get("HB-PRO-TOKEN") ||
        sessionStorage.getItem("HB-PRO-TOKEN") ||
        "",
    },
    pro: crm_token
      ? {
          "crm-token": crm_token,
          "crm-invite-code": invite_code_special,
        }
      : {
          "HB-API-VERSION": "1.6",
          "HB-PRO-TOKEN":
            cookies.get("HB-PRO-TOKEN") ||
            sessionStorage.getItem("HB-PRO-TOKEN") ||
            "",
        },
    hbg: {
      "crm-token": crm_token,
      "crm-invite-code": invite_code_special,
      "HB-PRO-TOKEN":
        cookies.get("HB-PRO-TOKEN") ||
        sessionStorage.getItem("HB-PRO-TOKEN") ||
        "",
    },
    ucHbg: {
      "crm-token": crm_token,
      "crm-invite-code": invite_code_special,
      "HB-UC-TOKEN":
        cookies.get("HB-UC-TOKEN") ||
        sessionStorage.getItem("HB-UC-TOKEN") ||
        "",
      "HB-PRO-TOKEN":
        cookies.get("HB-PRO-TOKEN") ||
        sessionStorage.getItem("HB-PRO-TOKEN") ||
        "",
    },
    nft: {
      "NFT-AUTH-TOKEN":
        cookies.get("NFT-AUTH-TOKEN") ||
        sessionStorage.getItem("NFT-AUTH-TOKEN") ||
        "",
      "HB-PRO-TOKEN":
        cookies.get("HB-PRO-TOKEN") ||
        sessionStorage.getItem("HB-PRO-TOKEN") ||
        "",
    },
  };
  return keysList[keys];
};

interface HbResponse {
  code?: number;
  data: any;
  message?: string;
  success: boolean;
  status?: string;
  "err-code"?: string;
  "err-msg"?: string;
}

const responseFormat = (fn): Promise<HbResponse> => {
  return new Promise((resolve) => {
    fn.then((v) => resolve(v.data)).catch((k) => resolve(k));
  });
};

class Https {
  public tokenKey: { [key: string]: string };
  public apiKeys: string;
  constructor(apiForm) {
    this.apiKeys = apiForm;
    this.tokenKey = tokenKeys(apiForm);
  }
  get(url, { data = {}, params = {}, headers = {} }): Promise<HbResponse> {
    this.tokenKey = tokenKeys(this.apiKeys);
    Object.assign(headers, this.tokenKey);
    return responseFormat(
      instance({ url, method: "get", data, params, headers })
    );
  }
  post(url, { data = {}, params = {}, headers = {} }): Promise<HbResponse> {
    this.tokenKey = tokenKeys(this.apiKeys);
    Object.assign(headers, this.tokenKey);
    return responseFormat(
      instance({ url, method: "post", data, params, headers })
    );
  }
  delete(url, { data = {}, params = {}, headers = {} }): Promise<HbResponse> {
    this.tokenKey = tokenKeys(this.apiKeys);
    Object.assign(headers, this.tokenKey);
    return responseFormat(
      instance({ url, method: "delete", data, params, headers })
    );
  }
  put(url, { data = {}, params = {}, headers = {} }): Promise<HbResponse> {
    this.tokenKey = tokenKeys(this.apiKeys);
    Object.assign(headers, this.tokenKey);
    return responseFormat(
      instance({ url, method: "put", data, params, headers })
    );
  }
}

export const uc = new Https("uc");
export const pro = new Https("pro");
export const hbg = new Https("hbg");
export const ucHbg = new Https("ucHbg");
export const nft = new Https("nft");
